module.exports = __webpack_public_path__ + "static/media/vi-VN.26a9c39a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/vi-VN.png
// module id = 958
// module chunks = 0